import { onMounted, ref } from 'vue'

export function useDetectOS() {
    const osType = ref<string>('')

    const detectOS = () => {
        const userAgent = window.navigator.userAgent || window.navigator.vendor

        if (/android/i.test(userAgent)) {
            osType.value = 'Android'
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            osType.value = 'iOS'
        } else if (/Win/.test(userAgent)) {
            osType.value = 'Windows'
        } else if (/Mac/.test(userAgent)) {
            osType.value = 'MacOS'
        } else if (/Linux/.test(userAgent)) {
            osType.value = 'Linux'
        } else {
            osType.value = 'Unknown'
        }
    }

    const isAppleEcosystem = computed(() => {
        return osType.value === 'MacOS' || osType.value === 'iOS'
    })

    onMounted(() => {
        detectOS()
    })

    return { osType, isAppleEcosystem }
}
